import { render, staticRenderFns } from "./Pointer.vue?vue&type=template&id=09b8d5e7"
import script from "./Pointer.vue?vue&type=script&lang=js"
export * from "./Pointer.vue?vue&type=script&lang=js"
import style0 from "./Pointer.vue?vue&type=style&index=0&id=09b8d5e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports